import { useRagnar } from '@mentimeter/ragnar-react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { FullSizeContainer } from '@mentimeter/visualizations-react/utils/full-size-container';
import { HundredPoints } from '@mentimeter/visualizations-react/visualizations/hundred-points';
import type { HundredPointsChoice, HundredPointsResult } from './types';

interface HundredPointsVisualizationProps {
  shouldHideResults: boolean;
  shouldAnimate: boolean;
  results: HundredPointsResult[];
  staticOptions: HundredPointsChoice[];
}

export const HundredPointsVisualization = ({
  shouldAnimate,
  shouldHideResults,
  results,
  staticOptions,
}: HundredPointsVisualizationProps) => {
  const {
    theme: {
      visualizationColors: { fillColors, textColor },
      colors: { border },
      fonts: { body },
    },
  } = useRagnar();

  const colors = fillColors.length > 0 ? fillColors : [textColor];

  return (
    <Box width="100%" height="100%" px="4%">
      <FullSizeContainer>
        {(width, height) => (
          <HundredPoints
            width={width}
            height={height}
            colors={colors as [string, ...[string]]}
            textColor={textColor}
            placeholderColor={border}
            data={results}
            fontFamily={body}
            disableAnimations={!shouldAnimate}
            isScoreHidden={shouldHideResults}
            staticOptions={staticOptions}
          />
        )}
      </FullSizeContainer>
    </Box>
  );
};
